<template>
  <span>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Name</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.vessel_name"
              class="form-control"
              autocomplete="off"
              placeholder="Name"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Code</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.code"
              class="form-control"
              autocomplete="off"
              placeholder="Code"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">DWT</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.dwt"
              class="form-control"
              autocomplete="off"
              placeholder="DWT"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Type Code</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.type_code"
              class="form-control"
              autocomplete="off"
              placeholder="Type Code"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Build Year</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.build_year"
              class="form-control"
              autocomplete="off"
              placeholder="Build Year"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">SW Summer Draft</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.sw_summer_draft"
              class="form-control"
              autocomplete="off"
              placeholder="SW Summer Draft"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Ownership</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.ownership"
              class="form-control"
              autocomplete="off"
              placeholder="Ownership"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Vessel Type</label>
          <div class="col-sm-12">
            <my-select
              disableFormControl="true"
              :selection.sync="form.vessel_type"
              :suggestions="vessel_types"
              placeholder="Select Vessel Type"
            ></my-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">TPC</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.tcp"
              class="form-control"
              autocomplete="off"
              placeholder="TPC"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">IMO Number</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.imo_number"
              class="form-control"
              autocomplete="off"
              placeholder="IMO Number"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Flag</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.flag"
              class="form-control"
              autocomplete="off"
              placeholder="Flag"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Capacity (Bale)</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.capacity_bale"
              class="form-control"
              autocomplete="off"
              placeholder="Capacity (Bale)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Daily Cost</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.daily_cost"
              class="form-control"
              autocomplete="off"
              placeholder="Daily Cost"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Capacity (Grain)</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.capacity_grain"
              class="form-control"
              autocomplete="off"
              placeholder="Capacity (Grain)"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Speed Laden</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.speed_laden"
              class="form-control"
              autocomplete="off"
              placeholder="Speed Laden"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Speed Ballast</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.capacity_ballast"
              class="form-control"
              autocomplete="off"
              placeholder="Speed Ballast"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Owner</label>
          <div class="col-sm-12">
            <my-select
              disableFormControl="true"
              :selection.sync="form.owner_id"
              :suggestions="owners"
              placeholder="Select Owner"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Scrubber Fitted</label>
          <div class="col-sm-12">
            <div class="form-check form-switch mb-2">
              <input
                type="checkbox"
                v-model="form.is_resigned"
                class="form-check-input"
                id="formSwitch1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Class Society</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.class_society"
              class="form-control"
              autocomplete="off"
              placeholder="Class Society"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Official Number</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.official_number"
              class="form-control"
              autocomplete="off"
              placeholder="Official Number"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Inmarsat Satcom Number</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.inmarsat_satcom_number"
              class="form-control"
              autocomplete="off"
              placeholder="Class Society"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label"> Last Dry Dock Date</label>
          <div class="col-sm-12">
            <!-- <div class="form-check form-switch"> -->
            <my-datepicker
              :date.sync="form.last_dry_dock_date"
              placeholder="Enter Date Of Birth"
            ></my-datepicker>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-2">
          <label class="col-form-label">Engine type</label>
          <div class="col-sm-12">
            <my-select
              disableFormControl="true"
              :selection.sync="form.engine_type"
              :suggestions="engneTypes"
              placeholder="Select Engine Type"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-2">
          <label class="col-form-label">Model number</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.model_number"
              class="form-control"
              autocomplete="off"
              placeholder="Model number"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Class Notation</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.class_notation"
              class="form-control"
              autocomplete="off"
              placeholder="Class Notation"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Service Speed</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.service_speed"
              class="form-control"
              autocomplete="off"
              placeholder="Service Speed"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-2">
          <label class="col-form-label">Ship Length (m)</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.ship_length"
              class="form-control"
              autocomplete="off"
              placeholder="Ship Length (m)"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-2">
          <label class="col-form-label">Bhp</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.bhp"
              class="form-control"
              autocomplete="off"
              placeholder="Bhp"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-2">
          <label class="col-form-label">Gross Tonnage</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.gross_tonnage"
              class="form-control"
              autocomplete="off"
              placeholder="Gross Tonnage"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-2">
          <label class="col-form-label">Net Tonnage</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.net_tonnage"
              class="form-control"
              autocomplete="off"
              placeholder="Net Tonnage"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Vessel Email</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.vessel_email"
              class="form-control"
              autocomplete="off"
              placeholder="Vessel Email"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Main Engine Power (kW)</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.main_engine_power"
              class="form-control"
              autocomplete="off"
              placeholder="Main Engine Power (kW)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Active</label>
          <div class="col-sm-12">
            <div class="form-check form-switch mb-2">
              <input
                type="checkbox"
                v-model="form.is_active"
                class="form-check-input"
                id="formSwitch1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-sm-12 col-form-label">Data entry mode</label>
          <div class="col-sm-6">
            <div class="form-check form-switch mb-2">
              <input
                type="checkbox"
                v-model="form.is_data_entry_mode"
                class="form-check-input"
                id="formSwitch1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-sm-12 col-form-label">License Active</label>
          <div class="col-sm-12">
            <div class="form-check form-switch mb-2">
              <input
                type="checkbox"
                v-model="form.is_license_active"
                class="form-check-input"
                id="formSwitch1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Project</label>
          <div class="col-sm-12">
            <div class="form-check form-switch mb-2">
              <input
                type="checkbox"
                v-model="form.is_project"
                class="form-check-input"
                id="formSwitch1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-sm-9 col-form-label">Is In License</label>
          <div class="col-sm-12">
            <div class="form-check form-switch mb-2">
              <input
                type="checkbox"
                v-model="form.is_in_license"
                class="form-check-input"
                id="formSwitch1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Sub Company Name</label>
          <div class="col-sm-12">
            <my-select
              disableFormControl="true"
              :selection.sync="form.sub_organzation_id"
              :suggestions="organzations"
              placeholder="Select Sub organzation"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Class Notation</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.class_notation"
              class="form-control"
              autocomplete="off"
              placeholder="Class Notation"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-form-label">Service Speed</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.service_speed"
              class="form-control"
              autocomplete="off"
              placeholder="Service Speed"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Code</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.code_1"
              class="form-control"
              autocomplete="off"
              placeholder="Code"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label"> User Id</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.user_id"
              class="form-control"
              autocomplete="off"
              placeholder="User Id"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-2">
          <label class="col-form-label">LDT</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.ldt"
              class="form-control"
              autocomplete="off"
              placeholder="LDT"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-2">
          <label class="col-form-label">Beam</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.beam"
              class="form-control"
              autocomplete="off"
              placeholder="Beam"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="mb-3">
          <label class="col-form-label">Description: </label>
          <div class="col-sm-12">
            <textarea
              name="Description"
              class="form-control"
              id=""
              cols="5"
              rows="5"
              v-model="form.description"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label class="col-form-label">Vessel registered address</label>
          <div class="col-sm-12">
            <textarea
              name="vessel_registered_address"
              class="form-control"
              id=""
              cols="5"
              rows="5"
              v-model="form.vessel_registered_address"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="mb-2">
          <label class="col-form-label">Attachment</label>
          <div class="col-sm-12">
            <input
              type="file"
              name="attachment"
              ref="file"
              class="form-control"
              autocomplete="off"
              placeholder="Attachment"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-2">
          <label class="col-form-label">Image Path</label>
          <div class="col-sm-12">
            <input
              type="file"
              name="imagepath"
              ref="file"
              class="form-control"
              autocomplete="off"
              placeholder="Image Path"
            />
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
// import axios from "axios";
export default {
  name: "VesselFormWidget",
  props: ["form"],
  data() {
    return {
      //   vessels: [],
    };
  },
  mounted() {
    // this.getMasters();
  },
  methods: {
    // async getMasters() {
    //   let masters = await axios.get("vessels/masters");
    //   masters = masters.data;
    //   masters.vessels.forEach((vessel) => {
    //     this.vessels.push({
    //       id: vessel.id,
    //       name: vessel.name,
    //     });
    //   });
    // },
  },
};
</script>
